import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DATE_TIME_FORMATE } from '@properties/date-time.properties';
import { TimezoneSharedService } from '@services/timezone/timezone-shared.service';

@Pipe({
  name: 'ToLocalDate',
  standalone: true,
})
export class ToLocalDatePipe implements PipeTransform {
  constructor(
    private readonly datePipe: DatePipe,
    private readonly timezoneSharedService: TimezoneSharedService,
  ) {}

  transform(value: Date): string {
    if (value) {
      const dateStr = value.toString();
      const safariDate = new Date(this.safariDate(dateStr));
      const timezone = this.timezoneSharedService.selectedTimezone;

      safariDate.setMinutes(safariDate.getMinutes() + timezone.offset);

      const convertedDate = this.datePipe.transform(new Date(safariDate), DATE_TIME_FORMATE);

      return `${convertedDate} (${timezone.shortName})`;
    }

    return '';
  }

  // todo: was taken from old code. Need to check it out.
  private safariDate(dateStr: string): string {
    if (!dateStr.includes('/')) {
      return (
        dateStr.split('-').join('/').split('T')[0].split('/')[1] +
        '/' +
        dateStr.split('-').join('/').split('T')[0].split('/')[2] +
        '/' +
        dateStr.split('-').join('/').split('T')[0].split('/')[0] +
        ' ' +
        dateStr.split('-').join('/').split('T')[1]
      );
    }

    return dateStr;
  }
}
